import { OptJobType } from 'api/optJobs/optJobs.api'
import { QueueItem } from 'api/queueItems/queueItems.types'
import { useAvailableSubtypes } from 'utils/systemUtils'
import { deriveQueueItemRows, QueueItemRow } from '../OptJobMultiPhaseProgress.helper'

function sortRows(items: QueueItem[]): QueueItem[] {
  return [...items].sort((a, b) => a.id - b.id)
}

/**
 * Binds queue items to the phase progress matrix: one row per item in id order.
 *
 * The clock comes from the caller rather than a ticker of its own, so a row and its
 * expanded panel are always reading the same instant. `jobHasEnded` closes items the
 * job left behind — see `deriveQueueItemPhaseDurations`.
 */
export function useQueueItemsPhaseProgress(
  queueItems: QueueItem[],
  optJobType: OptJobType,
  now: number,
  jobHasEnded = false
): QueueItemRow[] {
  const availableSubtypes = useAvailableSubtypes(optJobType)

  return deriveQueueItemRows(sortRows(queueItems), now, availableSubtypes, jobHasEnded)
}
